import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import orderDetailsHistoryUserPermissionDefinition from "./order-details-history-user-permission";

const useOrderDetailsHistoryUserPermissions = () => {
  return useUserPermissions(orderDetailsHistoryUserPermissionDefinition);
};

export default useOrderDetailsHistoryUserPermissions;
